var map = {
	"./back.png": "16de",
	"./chat-box.png": "e72c",
	"./device.svg": "0199",
	"./folder.png": "3f35",
	"./new-document.png": "2850",
	"./service.svg": "04a2",
	"./shield.png": "67e5",
	"./software.svg": "1616",
	"./store.svg": "52e1",
	"./trial.png": "2dc7",
	"./userLicense.svg": "ada5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8873";